import React from 'react';
import CustomSelect from 'app/components/CustomSelect';
import { Box, FormControl } from '@mui/material';
import FieldError from 'app/components/FieldError';
import logger from 'app/utils/logger';

interface Props {
  accountOptions?: any;
  selectedToAccount?: any;
  onChangeToAccount?: (value: any) => void;
  control?: any;
  register?: any;
  disabled?: boolean;
  errors?: any;
  dataForm?: any;
}

const GeneralDetailsMyAccounts = (props: Props) => {
  const { accountOptions, onChangeToAccount, selectedToAccount, control, register, disabled, errors, dataForm } = props;

  // logger.log('selectedToAccount');
  // logger.log(selectedToAccount);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '28px',
        width: 'calc((100% - 28px) / 2)',
        '@media screen and (max-width: 768px)': {
          flexDirection: 'column',
          width: '100%',
        },
      }}
    >
      <FormControl
        sx={{
          width: 'fit-content',
          '@media screen and (max-width: 1100px)': {
            width: '100%',
          },

          '@media screen and (max-width: 768px)': {
            width: '100%',
          },
        }}
      >
        <CustomSelect
          title={'Alan hesab'}
          placeholder={'Alan hesab'}
          options={accountOptions}
          rest={{ ...register('toAccount') }}
          control={control}
          optionValue={true}
          valueOption={'value'}
          optionLabel={true}
          labelOption={'label'}
          value={selectedToAccount}
          onChange={onChangeToAccount}
          disabled={disabled}
          isValid={errors?.toAccount !== undefined}
        />
        <FieldError error={errors.toAccount} />
      </FormControl>
    </Box>
  );
};

export default GeneralDetailsMyAccounts;
